export function zerosPaddingFilter() {
  function filter(){
    return function(input, n) {
      if(angular.isUndefined(input))
        input = "";
      if(input.length >= n)
        return input;
      var zeros = "";
      for(var i = 0; i < n; i++) {
        zeros+="0";
      }
      return (zeros + input).slice(-1 * n);
    };
  }
  return filter;
}


